import { FaPen } from 'react-icons/fa';
import { ImBin } from 'react-icons/im';
const SelectedTriggerItem = ({
  item,
  handleEditOption,
  handleDeleteOption,
}) => {
  return (
    <div className="text-md text-p-text min-h-[48px] cursor-pointer rounded-md bg-zinc-100 bg-opacity-10 px-3 py-2 font-semibold transition-colors duration-150 ease-in-out disabled:cursor-not-allowed">
      <div className="flex items-center gap-2">
        <div className="flex flex-1 flex-col gap-2">
          <div className="flex flex-col gap-2">
            <div className="flex min-h-[30px] items-center gap-2">
              <span className="flex-shrink-0">
                <div className="ml-2 rounded-lg bg-zinc-200 p-1">
                  <img alt={item.label} src={item.image} className="h-4 w-4" />
                </div>
              </span>
              <div className="min-w-0 flex-1 pr-6">
                <div className="text-s-text truncate text-sm font-medium">
                  {item.label}
                </div>
              </div>
            </div>
            {item.triggerPhrase && (
              <div class="br-1 bg-2 flex w-fit items-center rounded-[4px] border px-2 py-1 text-sm">
                <span class="font-semibold">Specific Phrase or Keyword</span>: "
                {item.triggerPhrase}"
              </div>
            )}
          </div>
          <ul className="flex flex-wrap gap-2">
            {item?.selectedFunctions?.length > 0 &&
              item?.selectedFunctions?.map((it, idx) => (
                <li
                  key={idx}
                  className="text-s-text rounded-full bg-zinc-100 px-3 py-1.5 text-sm text-zinc-800"
                >
                  {it.charAt(0).toUpperCase() + it.slice(1).toLowerCase()}
                </li>
              ))}
          </ul>
        </div>
        <div className="flex items-center gap-1">
          <button
            onClick={handleEditOption}
            className="btn btn-secondary mx-2 mr-2 rounded-lg p-2 text-sm text-zinc-200 hover:bg-zinc-900"
          >
            <FaPen />
          </button>
          <button
            onClick={() => handleDeleteOption(item.id)}
            className="btn btn-danger rounded-lg p-2 text-sm text-zinc-200 hover:bg-zinc-900"
          >
            <ImBin />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SelectedTriggerItem;
